var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-row', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b-col', [_c('h4', {
    staticClass: "title",
    class: _vm.classes
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('b-col', {
    staticClass: "title-actions"
  }, [_c('b-row', [_vm.hasPrint ? _c('b-col', {
    staticClass: "hidden-print",
    attrs: {
      "sm": "3"
    }
  }, [_c('Button', {
    staticClass: "btn-white",
    on: {
      "click": function click($event) {
        return _vm.print();
      }
    }
  }, [_c('Printer'), _vm._v(" Imprimir ")], 1)], 1) : _vm._e()], 1), _vm._t("actions")], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };